import { Component, Input } from '@angular/core';
import { MonitoringImage } from '../../cctv-monitoring.models';
import { imageAge } from '../../cctv-monitoring.utils';

@Component({
  selector: 'app-monitoring-stats',
  templateUrl: './monitoring-stats.component.html',
  styleUrls: ['./monitoring-stats.component.css'],
})
export class MonitoringStatsComponent {
  @Input() images: MonitoringImage[] = [];
  @Input() category: 'cabin' | 'outside' = 'cabin';

  get stats(): { title: string; value: number; icon: string; tone: string }[] {
    const current = this.images.filter(image => image.category === this.category);
    const ages = current.map(imageAge);
    return [
      { title: 'خودروهای دارای تصویر', value: new Set(this.images.map(image => image.unitId)).size, icon: 'fa-car', tone: 'vehicles' },
      { title: 'تصویر تازه (تا ۹۰ ثانیه)', value: ages.filter(age => age !== null && age <= 90).length, icon: 'fa-check-circle-o', tone: 'fresh' },
      { title: 'تأخیردار (تا ۱۸۰ ثانیه)', value: ages.filter(age => age !== null && age > 90 && age <= 180).length, icon: 'fa-clock-o', tone: 'delayed' },
      { title: 'تصویر قدیمی', value: ages.filter(age => age !== null && age > 180).length, icon: 'fa-history', tone: 'old' },
      { title: 'تصاویر دسته انتخابی', value: current.length, icon: 'fa-picture-o', tone: 'category' },
    ];
  }
}
